import { createContext } from 'react'
import type { DateContextValue } from './types'

export const DateContext = createContext<DateContextValue | null>(null)
